let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lUh4r")).then(() => parcelRequire('hgGNe'));